import { Link } from "react-router-dom";
import { comicGenres } from "@/mocks/comics";

const genreBlurbs: Record<string, string> = {
  热血: "燃烧斗志的长篇战斗神作",
  科幻: "硬核设定与宏大想象",
  奇幻: "魔法与史诗交织的世界",
  日常: "治愈平凡生活的暖心故事",
  悬疑: "烧脑推理与都市谜团",
  冒险: "勇敢出发的浪漫与勇气",
};

export default function GenreNav() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-bold text-primary-600">题材分类</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            按喜好快速定位你的长篇漫画
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            六大热门题材，每个分类都汇聚了长期连载、稳定更新的精品力作。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6 md:gap-5">
          {comicGenres.map((g) => (
            <Link
              key={g.name}
              to={`/series?genre=${g.name}`}
              className="group flex flex-col items-center rounded-lg border border-background-200/70 bg-background-50 px-4 py-6 text-center transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-600 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${g.icon} text-xl`}></i>
              </span>
              <span className="mt-3 text-sm font-bold text-foreground-950">{g.name}</span>
              <span className="mt-1 text-xs leading-relaxed text-foreground-500">
                {genreBlurbs[g.name]}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}